import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { ApiManager } from '../../../core/api-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalEntityCompiler from '../../../components/Modals/ModalEntityCompiler';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Utils } from '../../../core/utils';
import { ViewManager } from '../../../core/view-manager';
import { LoginManager } from '../../../core/login-manager';
import { prepareSupplierOrderTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';




export default function DGLTH_supplier_order({ item, entity = null, refreshData }) {

    const navigate = useNavigate();
    const userInfo = LoginManager.getUserInfo();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [generateErrors, setGenerateErrors] = useState([]);
    const [packages, setPackages] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [modalConfirmSupplierOrderStatus, setModalConfirmSupplierOrderStatus] = useState(false);
    const [generateReport, setGenerateReport] = useState(null);
    const [forceLoading, setForceLoading] = useState(false);
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns('supplier_transport_document'));


    function openModal() {
        setShowModal(true)
    }
    function closeModal() {
        setShowModal(false)
    }

    async function handleConfirmSupplierOrder() {
        var statusValue = "15_TO_LOAD"
        if (item.typeOrder?.value === "0_CONTO_LAVORO" || item.typeOrder?.value === "15_RIPRISTINO") {
            statusValue = "2_CONFIRMED"
        }
        const response = await DataManager.updateItem('supplier_order', {
            status: { value: statusValue }
        }, item.id);
        if (response.success === 1) {
            refreshData();
        }
    }

    useEffect(() => {
        if (modalConfirmSupplierOrderStatus === true) {
            //get della distinta
        }
    }, [modalConfirmSupplierOrderStatus]);





    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    function closeModalCompiler() {
        setModalCompilerStatus(false);
    }

    async function openModalCompiler() {
        setConfirmLoading(true);
        try {
            var res = await DataManager.getItem('supplier_order', item.id);
            if (res.success === 1 && res.body.length > 0) {
                setModalCompilerInitData(res.body[0])
                setModalCompilerStatus(true);
            }
        } finally {
            setConfirmLoading(false);
        }
    }





    async function modalCompilerSave(el) {
        console.log('el', el, modalCompilerInitData)

        setConfirmLoading(true);
        try {
            // update
            var response = await DataManager.updateItem('supplier_order', el, modalCompilerInitData.id);
            if (response.success === 1) {
                await handleConfirmSupplierOrder();
                setModalCompilerInitData(null);
                closeModalCompiler();
            }
            else {
                console.warn(response);
            }
        } finally {
            setConfirmLoading(false);
        }

    }


    function sendEmail() {
        navigate('/page/SendDocumentEmailSupplierOrder?id=' + item.id + '&e=supplier_order')
    }

    async function loadPrintData() {
        const res = await DataManager.getItem('supplier_order', item.id);
        if (res.success !== 1) return null;
        const data = res.body[0];
        return {
            fileDocument: data.fileDocument,
            templateData: prepareSupplierOrderTemplateData(data),
            filename: 'ordine_fornitore_' + data.internalCode,
            entity: 'supplier_order',
            id: item.id
        };
    }


    /* async function generateDDT() {
        if (loading) return;
        setLoading(true);
        setGenerateErrors([]);
        const errors = [];
        var response = await DataManager.getItem("supplier_order", item.id);
        if (response.success === 1) {
            console.log(response.body[0])
            var so = response.body[0];
            for (let i = 0; i < so.rows.length; i++) {
                var constraints = [
                    { fieldName: "idItemModel", type: "value", value: so.rows[i].idItemModel.id },
                    { fieldName: "isDefault", type: "value", value: 1 }
                ]
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var r = await DataManager.searchItems('manufacturing_process_model', 1, 1, sorting, '', {}, constraints)
                console.log(r)
                if (r.success === 1 && r.body.length > 0) {
                    so.rows[i].children = r.body[0].children;
                } else {
                    so.rows[i].children = [];
                    errors.push({
                        message: "L'articolo non ha figli.",
                        code: so.rows[i].idItemModel.code,
                        name: so.rows[i].idItemModel.name,
                        quantity: so.rows[i].quantity,
                        requiredQuantity: so.rows[i].quantity,
                        availableQuantity: 0
                    });
                }
                console.log('righe', so.rows);
            }

            console.warn(so)
            const row = [];
            var weight = "";
            var packagesQuantity = "";
            so.rows.forEach(element => {
                if (element.children && element.children.length > 0) {
                    console.log(element.children)
                    element.children.forEach(child => {
                        console.log('BETA', child, element)
                        let rowData = {
                            'idItemModel': child.idItemModel.id,
                            'quantity': parseFloat(child.quantity) * parseFloat(element.quantity),
                            'name': child.idItemModel.name,
                            'measureUnit': child.idItemModel.measureUnit,
                            'status': { value: '0_PENDING' },
                            'notes': element.notes
                        }
                        row.push(rowData);
                    });
                    weight = element.children.reduce((acc, cur) => acc + parseFloat(cur.idItemModel.grossWeight), 0);
                    packagesQuantity = element.children.reduce((acc, cur) => acc + parseFloat(cur.idItemModel.packages), 0);
                    console.log(weight)
                } else {
                    // articoli senza figli già raccolti in errors
                }
            });

            console.log(row)

            if (row && row.length > 0) {
                const body = {
                    idSupplier: so.idSupplier.id,
                    idSupplierOrder: so.id,
                    rifOrder: so.internalCode,
                    idTransportDocumentReason: so.scope ? so.scope.id : null,
                    itemsAspect: so.itemsAspect ? so.itemsAspect.value : null,
                    transportBy: so.transportBy ? so.transportBy.value : null,
                    idForwarder: so.idForwarder ? so.idForwarder.id : null,
                    notes: null,
                    rows: row,
                    idWarehouseFinish: so.idWarehouseStart ? so.idWarehouseStart.id : null,
                    idWarehouseStart: so.idWarehouseFinish ? so.idWarehouseFinish.id : null,
                    weight: weight,
                    packagesQuantity: parseInt(packages)
                }
                console.warn(body);

                var responseCreate = await ApiManager.sendAuthenticatedRequest('/custom/create_supplier_ddt', body);
                console.log(responseCreate);

                if (responseCreate.errors && Array.isArray(responseCreate.errors) && responseCreate.errors.length > 0) {
                    responseCreate.errors.forEach(err => {
                        errors.push({
                            message: err.message || 'Errore nella creazione del DDT.',
                            code: err.code || null,
                            name: err.name || null,
                            quantity: err.quantity || null,
                            requiredQuantity: err.requiredQuantity !== undefined ? err.requiredQuantity : (err.quantity || null),
                            availableQuantity: err.availableQuantity !== undefined ? err.availableQuantity : null
                        });
                    });
                }

                if (responseCreate.success === 1 && responseCreate.status === 200 && errors.length === 0) {
                    toast.success('DDT creato con successo!', { theme: 'colored' });
                    const dataUpdateStatus = {
                        status: { value: '15_TO_LOAD' }
                    }
                    var resUpdateStatus = await DataManager.updateItem('supplier_order', dataUpdateStatus, item.id);
                    if (resUpdateStatus.success === 1) {
                        var params = {
                            'query': '',
                            'fields': searchableFields,
                            'constraints': [{ fieldName: "idSupplierOrder", type: "value", value: so.id }]
                        }
                        setLoading(false);
                        navigate('/entity/supplier_transport_document?q=' + btoa(JSON.stringify(params)))
                    }
                } else {
                    setLoading(false);
                    if (errors.length === 0) {
                        errors.push({
                            message: responseCreate.message || 'Errore nella creazione del DDT.',
                            code: null,
                            name: null,
                            quantity: null,
                            requiredQuantity: null,
                            availableQuantity: null
                        });
                    }
                    setGenerateErrors(errors);
                }
            } else {
                setLoading(false);
                if (errors.length === 0) {
                    errors.push({
                        message: 'Non è stato possibile generare il DDT perché gli articoli non hanno figli.',
                        code: null,
                        name: null,
                        quantity: null,
                        requiredQuantity: null,
                        availableQuantity: null
                    });
                }
                setGenerateErrors(errors);
            }



        } else {
            setLoading(false);
            setGenerateErrors([{
                message: response.message || 'Errore nel recupero dell\'ordine fornitore.',
                code: null,
                name: null,
                quantity: null,
                requiredQuantity: null,
                availableQuantity: null
            }]);
        }
    } */


    async function generateDDTB() {
        if (loading) return;
        setLoading(true);
        setGenerateErrors([]);
        setGenerateReport(null);
        const errors = [];
        try {
            const body = {
                orderId: item.id,
                packagesQuantity: packages ? parseInt(packages) : null
            };
            console.log(body);
            const res = await ApiManager.sendAuthenticatedRequest('/custom/generate_supplier_ddt', body);
            console.log(res);

            if (res && res.success === 1) {
                toast.success('DDT creato con successo!', { theme: 'colored' });
                const dataUpdateStatus = {
                    status: { value: '15_TO_LOAD' }
                };
                const resUpdateStatus = await DataManager.updateItem('supplier_order', dataUpdateStatus, item.id);
                if (resUpdateStatus.success === 1) {
                    const report = res.report || (res.body && res.body.report) || null;
                    setGenerateReport(report);
                }
            } else {
                if (res && res.errors && Array.isArray(res.errors) && res.errors.length > 0) {
                    res.errors.forEach(err => {
                        errors.push({
                            message: err.message || 'Errore nella creazione del DDT.',
                            code: err.code || null,
                            name: err.name || null,
                            requiredQuantity: err.requiredQuantity !== undefined ? err.requiredQuantity : (err.quantity || null),
                            availableQuantity: err.availableQuantity !== undefined ? err.availableQuantity : null,
                            availableQuantitySupplier: err.availableQuantitySupplier !== undefined ? err.availableQuantitySupplier : null,
                            availableQuantityDefault: err.availableQuantityDefault !== undefined ? err.availableQuantityDefault : null,
                            missingQuantity: err.missingQuantity !== undefined ? err.missingQuantity : null
                        });
                    });
                }
                if (errors.length === 0) {
                    errors.push({
                        message: (res && res.message) || 'Errore nella creazione del DDT.',
                        code: null,
                        name: null,
                        quantity: null,
                        requiredQuantity: null,
                        availableQuantity: null
                    });
                }
                setGenerateErrors(errors);
            }
        } finally {
            setLoading(false);
        }
    }


    function goToFilteredSupplierDDT() {
        const params = {
            query: '',
            fields: searchableFields,
            constraints: [{ fieldName: "idSupplierOrder", type: "value", value: item.id }]
        };
        navigate('/entity/supplier_transport_document?q=' + btoa(JSON.stringify(params)));
    }

    async function forceStatusChange() {
        if (forceLoading) return;

        const confirmMessage = 'Sei sicuro di voler forzare il cambio di stato dell\'ordine a "Da evadere" senza generare il DDT?';
        if (!window.confirm(confirmMessage)) {
            return;
        }

        setForceLoading(true);
        try {
            const dataUpdateStatus = {
                status: { value: '15_TO_LOAD' }
            };
            const resUpdateStatus = await DataManager.updateItem('supplier_order', dataUpdateStatus, item.id);
            if (resUpdateStatus.success === 1) {
                toast.success('Stato dell\'ordine aggiornato a "Da evedere"', { theme: 'colored' });
                closeModal();
                if (refreshData) {
                    refreshData();
                }
            } else {
                toast.error('Errore nell\'aggiornamento dello stato', { theme: 'colored' });
            }
        } catch (error) {
            toast.error('Errore nell\'aggiornamento dello stato: ' + error.message, { theme: 'colored' });
        } finally {
            setForceLoading(false);
        }
    }


    const status = item.status ? item.status.value : null;
    const typeOrder = item.typeOrder ? item.typeOrder.value : null;


    return (
        <>


            {parseInt(userInfo?.level) !== 3 ? <>



                {/* INDICATORE RIGHE PENDING */}
                {userInfo.level !== 3 && status === "15_TO_LOAD" && item.rows_pending === item.rows ? <FontAwesomeIcon icon="circle" color="red" size="lg" className='me-1' /> : null}
                {userInfo.level !== 3 && status === "15_TO_LOAD" && item.rows_pending !== item.rows ? <FontAwesomeIcon icon="circle" color="#ffc107" size="lg" className='me-1' /> : null}



                {/* CONTO LAVORO */}
                {typeOrder === "0_CONTO_LAVORO" ? <>
                    {status === "0_DRAFT" ? <>
                        <Button onClick={openModalCompiler} className='m-1' variant='success' size='sm' disabled={confirmLoading}>
                            {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                            Conferma
                        </Button>
                    </> : null}
                    {status === "2_CONFIRMED" ? <>
                        <Button className='me-1' variant='dark' size='sm' onClick={() => openModal()}>Genera DDT</Button>
                    </> : null}
                    {status === "15_TO_LOAD" ? <>
                        <Link to={'/page/LoadSupplier?id=' + item.id}>
                            <Button className='me-1' variant='primary' size='sm'>
                                Carica merce
                            </Button>
                        </Link>
                    </> : null}
                    <Button variant='outline-dark' size='sm' className='me-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }}>Bindelle</Button>
                    <Link to={'/page/ListaFigli?id=' + item.id}>
                        <Button className='m-1' variant='outline-success' size='sm'>Stampa figli</Button>
                    </Link>
                </> : null}





                {/* MATERIA PRIMA */}
                {typeOrder === "5_MATERIA_PRIMA" ? <>
                    {status === "0_DRAFT" ? <>
                        <Button onClick={openModalCompiler} className='m-1' variant='success' size='sm' disabled={confirmLoading}>
                            {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                            Conferma
                        </Button>
                    </> : null}
                    {status === "15_TO_LOAD" ? <>
                        <Link to={'/page/LoadSupplier?id=' + item.id}>
                            <Button className='me-1' variant='primary' size='sm'>
                                Carica merce
                            </Button>
                        </Link>
                    </> : null}
                    <Button variant='outline-dark' size='sm' className='me-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }}>Bindelle</Button>
                </> : null}





                {/* PRODUZIONE INTERNA */}
                {typeOrder === "10_PRODUZIONE_INTERNA" ? <>
                    {status === "0_DRAFT" ? <>
                        <Button onClick={openModalCompiler} className='m-1' variant='success' size='sm' disabled={confirmLoading}>
                            {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                            Conferma
                        </Button>
                    </> : null}
                    {status === "15_TO_LOAD" ? <>
                        <Link to={'/page/LoadSupplier?id=' + item.id}>
                            <Button className='me-1' variant='primary' size='sm'>
                                Carica merce
                            </Button>
                        </Link>
                    </> : null}
                    <Button variant='outline-dark' size='sm' className='me-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }}>Bindelle</Button>
                    <Link to={'/page/ListaFigli?id=' + item.id}>
                        <Button className='m-1' variant='outline-success' size='sm'>Stampa figli</Button>
                    </Link>
                </> : <></>}

                {/* RIPRISTINO */}
                {typeOrder === "15_RIPRISTINO" ? <>
                    {status === "0_DRAFT" ? <>
                        <Button onClick={openModalCompiler} className='m-1' variant='success' size='sm' disabled={confirmLoading}>
                            {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                            Conferma
                        </Button>
                    </> : null}
                    {status === "2_CONFIRMED" ? <>
                        <Button className='me-1' variant='dark' size='sm' onClick={() => openModal()}>Genera DDT</Button>
                    </> : null}
                    {status === "15_TO_LOAD" ? <>
                        <Link to={'/page/LoadSupplier?id=' + item.id}>
                            <Button className='me-1' variant='primary' size='sm'>
                                Carica merce
                            </Button>
                        </Link>
                    </> : null}
                    <Button variant='outline-dark' size='sm' className='me-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }}>Bindelle</Button>
                </> : null}


                <PrintDocxButton
                    templateKey="template_order_supplier"
                    loadData={loadPrintData}
                    buttonLabel=""
                    className="m-1"
                    icon="print"
                />
                <Button className='m-1' size='sm' variant='outline-primary' onClick={() => { sendEmail() }}>
                    <FontAwesomeIcon icon={'envelope'} />
                </Button>




            </> : <>
                <div className='d-flex flex-column me-2' style={{ gap: '0.25rem' }}>
                    {/* CONTO LAVORO */}
                    {typeOrder === "0_CONTO_LAVORO" ? <>
                        {status === "0_DRAFT" ? <>
                            <Button onClick={openModalCompiler} className='mb-1' variant='success' size='sm' disabled={confirmLoading} style={{ width: '100%' }}>
                                {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Conferma
                            </Button>
                        </> : null}
                        {status === "2_CONFIRMED" ? <>
                            <Button className='mb-1' variant='dark' size='sm' onClick={() => openModal()} style={{ width: '100%' }}>Genera DDT</Button>
                        </> : null}
                        {status === "15_TO_LOAD" ? <>
                            <Link to={'/page/LoadSupplier?id=' + item.id}>
                                <Button className='mb-1' variant='primary' size='sm' style={{ width: '100%' }}>
                                    Carica merce
                                </Button>
                            </Link>
                        </> : null}
                        <Button variant='outline-dark' size='sm' className='mb-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }} style={{ width: '100%' }}>Bindelle</Button>
                        <Link to={'/page/ListaFigli?id=' + item.id}>
                            <Button className='mb-1' variant='outline-success' size='sm' style={{ width: '100%' }}>Stampa figli</Button>
                        </Link>
                    </> : null}





                    {/* MATERIA PRIMA */}
                    {typeOrder === "5_MATERIA_PRIMA" ? <>
                        {status === "0_DRAFT" ? <>
                            <Button onClick={openModalCompiler} className='mb-1' variant='success' size='sm' disabled={confirmLoading} style={{ width: '100%' }}>
                                {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Conferma
                            </Button>
                        </> : null}
                        {status === "15_TO_LOAD" ? <>
                            <Link to={'/page/LoadSupplier?id=' + item.id}>
                                <Button className='mb-1' variant='primary' size='sm' style={{ width: '100%' }}>
                                    Carica merce
                                </Button>
                            </Link>
                        </> : null}
                    </> : null}





                    {/* PRODUZIONE INTERNA */}
                    {typeOrder === "10_PRODUZIONE_INTERNA" ? <>
                        {status === "0_DRAFT" ? <>
                            <Button onClick={openModalCompiler} className='mb-1' variant='success' size='sm' disabled={confirmLoading} style={{ width: '100%' }}>
                                {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Conferma
                            </Button>
                        </> : null}
                        {status === "15_TO_LOAD" ? <>
                            <Link to={'/page/LoadSupplier?id=' + item.id}>
                                <Button className='mb-1' variant='primary' size='sm' style={{ width: '100%' }}>
                                    Carica merce
                                </Button>
                            </Link>
                        </> : null}
                        <Button variant='outline-dark' size='sm' className='mb-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }} style={{ width: '100%' }}>Bindelle</Button>
                        <Link to={'/page/ListaFigli?id=' + item.id}>
                            <Button className='mb-1' variant='outline-success' size='sm' style={{ width: '100%' }}>Stampa figli</Button>
                        </Link>
                    </> : <></>}

                    {/* RIPRISTINO */}
                    {typeOrder === "15_RIPRISTINO" ? <>
                        {status === "0_DRAFT" ? <>
                            <Button onClick={openModalCompiler} className='mb-1' variant='success' size='sm' disabled={confirmLoading} style={{ width: '100%' }}>
                                {confirmLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Conferma
                            </Button>
                        </> : null}
                        {status === "2_CONFIRMED" ? <>
                            <Button className='mb-1' variant='dark' size='sm' onClick={() => openModal()} style={{ width: '100%' }}>Genera DDT</Button>
                        </> : null}
                        {status === "15_TO_LOAD" ? <>
                            <Link to={'/page/LoadSupplier?id=' + item.id}>
                                <Button className='mb-1' variant='primary' size='sm' style={{ width: '100%' }}>
                                    Carica merce
                                </Button>
                            </Link>
                        </> : null}
                        <Button variant='outline-dark' size='sm' className='mb-1' onClick={() => { navigate('/page/BindellaSupplierOrder?id=' + item.id) }} style={{ width: '100%' }}>Bindelle</Button>
                    </> : null}

                </div>


            </>}






            <ModalEntityCompiler entity={'supplier_order'} initData={modalCompilerInitData} close={closeModalCompiler} status={modalCompilerStatus} confirmCallback={modalCompilerSave} />


            <Modal show={showModal} onHide={closeModal} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Generazione documenti</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Inserire numero di colli</Form.Label>
                        <Form.Control type="number" onChange={(e) => setPackages(e.target.value)} />
                    </Form.Group>
                    {loading ? <div className='text-center p-3'>
                        <Spinner animation="border" variant="primary" />
                        <p className='text-primary'>Generazione in corso...</p>
                    </div> : null}
                    {generateReport && (
                        <div className='mt-3'>
                            <h5>Riepilogo generazione DDT</h5>
                            <p>Righe completamente evase: <b>{generateReport.fullRows ? generateReport.fullRows.length : 0}</b></p>
                            {generateReport.fullRows && generateReport.fullRows.length > 0 && (
                                <Table bordered size='sm' className='mb-3'>
                                    <thead>
                                        <tr>
                                            <th>Articolo</th>
                                            <th>Quantità richiesta</th>
                                            <th>Disponibile</th>
                                            <th>Inviata</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {generateReport.fullRows.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.name}</td>
                                                <td>{row.requiredQuantity}</td>
                                                <td>{row.availableQuantity}</td>
                                                <td>{row.sentQuantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}

                            <p>Righe parziali: <b>{generateReport.partialRows ? generateReport.partialRows.length : 0}</b></p>
                            {generateReport.partialRows && generateReport.partialRows.length > 0 && (
                                <Table bordered size='sm' className='mb-3'>
                                    <thead>
                                        <tr>
                                            <th>Articolo</th>
                                            <th>Quantità richiesta</th>
                                            <th>Disponibile</th>
                                            <th>Inviata</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {generateReport.partialRows.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.name}</td>
                                                <td>{row.requiredQuantity}</td>
                                                <td>{row.availableQuantity}</td>
                                                <td>{row.sentQuantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}

                            <p>Righe non inviate: <b>{generateReport.skippedRows ? generateReport.skippedRows.length : 0}</b></p>
                            {generateReport.skippedRows && generateReport.skippedRows.length > 0 && (
                                <Table bordered size='sm' className='mb-3'>
                                    <thead>
                                        <tr>
                                            <th>Articolo</th>
                                            <th>Quantità richiesta</th>
                                            <th>Disponibile</th>
                                            <th>Inviata</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {generateReport.skippedRows.map((row, i) => (
                                            <tr key={i}>
                                                <td>{row.name}</td>
                                                <td>{row.requiredQuantity}</td>
                                                <td>{row.availableQuantity}</td>
                                                <td>{row.sentQuantity}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </div>
                    )}
                    {!generateReport && generateErrors && generateErrors.length > 0 && (
                        <div className='mt-3'>
                            <Alert variant='danger'>
                                <Alert.Heading>Errori nella generazione del DDT</Alert.Heading>
                                {generateErrors.map((err, i) => (
                                    <div key={i} className={i > 0 ? 'mt-3 pt-3' : ''} style={i > 0 ? { borderTop: '1px solid #f5c2c7' } : {}}>
                                        {err.message && <p className='mb-2'><strong>{err.message}</strong></p>}
                                        {err.code && <p className='mb-1'>Codice articolo: <strong>{err.code}</strong></p>}
                                        {err.name && <p className='mb-1'>Descrizione: <strong>{err.name}</strong></p>}
                                        {(err.requiredQuantity !== undefined && err.requiredQuantity !== null) && (
                                            <p className='mb-1'>Quantità richiesta: <strong>{err.requiredQuantity}</strong></p>
                                        )}
                                        {(err.availableQuantitySupplier !== undefined && err.availableQuantitySupplier !== null) && (
                                            <p className='mb-1'>Disponibile presso fornitore: <strong>{err.availableQuantitySupplier}</strong></p>
                                        )}
                                        {(err.availableQuantityDefault !== undefined && err.availableQuantityDefault !== null) && (
                                            <p className='mb-1'>Disponibile in locazione default: <strong>{err.availableQuantityDefault}</strong></p>
                                        )}
                                        {(err.availableQuantity !== undefined && err.availableQuantity !== null) && (
                                            <p className='mb-1'>Totale disponibile: <strong>{err.availableQuantity}</strong></p>
                                        )}
                                        {(err.missingQuantity !== undefined && err.missingQuantity !== null) && (
                                            <p className='mb-0 text-danger'>Quantità mancante: <strong>{err.missingQuantity}</strong></p>
                                        )}
                                    </div>
                                ))}
                            </Alert>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!generateReport && (
                        <>
                            <Button variant='outline-danger' onClick={() => closeModal()}>Annulla</Button>
                            {generateErrors && generateErrors.length > 0 && (
                                <Button variant='warning' onClick={() => forceStatusChange()} disabled={forceLoading || loading}>
                                    {forceLoading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                    Forza cambio di stato
                                </Button>
                            )}
                            <Button variant='primary' onClick={() => generateDDTB()} disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Genera
                            </Button>
                        </>
                    )}
                    {generateReport && (
                        <>
                            <Button variant='outline-secondary' onClick={() => closeModal()}>Chiudi</Button>
                            <Button variant='primary' onClick={() => goToFilteredSupplierDDT()}>
                                Vai ai DDT generati
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

        </>
    )
};
